"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M1.25 3.677C1.25 1.644 2.937 0 5 0h14c2.063 0 3.75 1.644 3.75 3.677v12.73c0 2.032-1.687 3.676-3.75 3.676h-1.734l-4.787 3.743A.747.747 0 0 1 12 24a.794.794 0 0 1-.307-.068l-.003-.002a.732.732 0 0 1-.44-.67v-3.177H5c-2.063 0-3.75-1.644-3.75-3.677V3.677Zm7.458 3.616c.39.39.39 1.028 0 1.42h.02A1.06 1.06 0 0 1 8.01 9a.973.973 0 0 1-.718-.288 1.001 1.001 0 1 1 1.415-1.419Zm6.581 1.42a1.015 1.015 0 0 1 0-1.42h.02a.984.984 0 0 1 1.402 0c.385.39.385 1.028 0 1.42A1.044 1.044 0 0 1 16 9a.958.958 0 0 1-.71-.288Zm1.155 2.52a.742.742 0 0 0-.602.064c-3.748 1.986-7.592.048-7.686 0h-.001a.794.794 0 0 0-1.064.323.784.784 0 0 0 .333 1.064c.215.118 2.14 1.097 4.73 1.097a9.26 9.26 0 0 0 4.43-1.097.785.785 0 0 0 .322-1.064.745.745 0 0 0-.473-.387h.011Z",
    clipRule: "evenodd"
  })]
});